export default __webpack_public_path__ + "static/media/foot_length.c645bd23.webp";